import { isNil } from 'lodash-es';
import { formatNumber } from 'utils/numberFormat';

// eslint-disable-next-line import/prefer-default-export
export const numDisplay = (num?: number) => {
  if (isNil(num)) {
    return '-';
  }
  return formatNumber(num, '0,0.00');
};
